import { render, staticRenderFns } from "./language-selector.vue?vue&type=template&id=34343d4b&scoped=true&lang=pug"
import script from "./language-selector.vue?vue&type=script&lang=coffee"
export * from "./language-selector.vue?vue&type=script&lang=coffee"
import style0 from "./language-selector.vue?vue&type=style&index=0&id=34343d4b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34343d4b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormSelect: require('/opt/build/repo/site/components/globals/form/select.vue').default})
